import moment from "moment";

import { User } from "../../types/user";
import { mapRoleDisplay } from "../../utils/mapRoleDisplay";

import styles from "./user-list-component.module.css";

interface UsersCardProps {
  user: User;
  color?: string;
  onClick?: () => void;
}

const UsersCard: React.FC<UsersCardProps> = ({ user, color, onClick }) => {
  return (
    <div
      className={styles["card"]}
      onClick={onClick}
      style={{ backgroundColor: color }}
    >
      <p className={styles["name"]}>
        {user.lastName}, {user.firstName}
      </p>
      <p className={styles["mail"]}>{user.email}</p>
      <div className={styles["tags"]}>
        <div className={styles["tags"]}>
          <div className={styles["card__tags"]}>
            {user?.roles?.filter(Boolean).map((role) => (
              <p key={role} className={styles["card__type--responsibility"]}>
                {mapRoleDisplay(role)}
              </p>
            ))}
          </div>
        </div>
        <p className={styles["date"]}>
          letzter Login:{" "}
          {user.lastLoginDate &&
            moment(user.lastLoginDate).format("DD.MM.YYYY")}
        </p>
      </div>
    </div>
  );
};

export default UsersCard;
